import { render, staticRenderFns } from "./PaymentComponent.vue?vue&type=template&id=69d24d08&"
import script from "./PaymentComponent.vue?vue&type=script&lang=ts&"
export * from "./PaymentComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports